import { Box, Card, Typography } from '@mui/material'
import React from 'react'
import Header from '../Header'
import Footer from '../Footer';
import { styles } from '../../styles/styles';
import { FontStyles } from '../../styles/FontStyles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
const About = () => {
    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box sx={{
                marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "10%" }
            }}>
                <Card
                    sx={{
                        ...styles.aboutcard,
                        boxShadow: 3,
                    }}
                >
                    <DecorativeCorner sx={{ top: -20, left: -20 }} />
                    <DecorativeCorner sx={{ top: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                    <Typography variant="h4" component="h1" sx={FontStyles.heading1}>
                        About Annapurna Marriages
                    </Typography>
                    <Card
                        sx={{
                            ...styles.aboutCard,
                            boxSizing: "border-box",
                        }}
                    >
                        <Typography sx={{ ...FontStyles.aboutText }}>
                            <span style={{
                                 ...FontStyles.aboutSpan
                            }}>Annapurna Marriages Pvt Ltd.</span> is the fastest growing marriage portal in Andhra Pradesh & Telangana states. The online marriage portal aims to serve as a one-stop platform for prospective brides and grooms to meet and communicate with each other. It offers a superior matchmaking experience by expanding the opportunities available to meet potential life partners and build fulfilling relationships.
                        </Typography>
                        <Typography sx={{ ...FontStyles.aboutText }}>
                            We use the latest and most cutting edge technologies available in the environment to provide members with fast, relevant, and best matching results in strict confidence. We fulfill the needs of today’s eligible singles who are searching for convenient and effective ways to meet with prospective partners.
                        </Typography>
                        <Typography sx={{ ...FontStyles.aboutText }}>
                            Our quality team ensures that every profile put up at {""}
                            <span style={{
                                ...FontStyles.aboutSpan
                            }}>
                                www.annapurnamarriages.com </span>
                            is screened for irrelevant and/or appropriate content. It also has strict abuse prevention and reporting systems for individuals who are accepted via our screening system.
                        </Typography>
                        <Typography sx={{ ...FontStyles.aboutText }}>
                            <span style={{
                                 ...FontStyles.aboutSpan
                            }}>
                                Annapurna Marriages Pvt Ltd.</span> is being run from 2015 with one simple objective to provide a superior match making experience by expanding the opportunities available to meet potential life partners.
                        </Typography>
                        <Typography sx={{ ...FontStyles.aboutText }}>
                            We are undoubtedly the most trusted name in the marriage service. We behind the holiness of traditionally arranged marriages with the interactivity of internet technologies.
                        </Typography>
                    </Card>
                </Card>
                <Box sx={{ marginTop: "50px" }}>
                    <Card
                        sx={{
                            ...styles.aboutcard,
                            boxShadow: 3,
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                        <Typography variant="h4" component="h1" sx={FontStyles.heading1}>
                            Who We  Are?
                        </Typography>
                        <Typography sx={{ ...FontStyles.aboutText }}>

                            Our  <span style={{
                                 ...FontStyles.aboutSpan
                            }}>MD Purna Chandhar Rao Bellam</span> started Annapurna Marriages Pvt Ltd. for match making service. Marriage is a bond which unities two souls in a wedlock, partnership that last till end scarps them apart.<span style={{
                                 ...FontStyles.aboutSpan
                            }}> annapurnamarriages.com </span>is an India’s best-known marriage bureau and India’s largest marriage services was founded with a simple objective is to introduce suitable life partners to the prospective Bride / Bride Groom.
                        </Typography>
                    </Card>
                </Box>
                <Box sx={{ marginTop: "50px" }}>
                    <Card
                        sx={{
                            ...styles.aboutcard,
                            boxShadow: 3,
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                        <Typography variant="h4" component="h1" sx={FontStyles.heading1}>
                            Our Objective                    </Typography>
                        <Card
                            sx={{
                                ...styles.aboutCard,
                                boxSizing: "border-box",
                            }}
                        >
                            <Typography sx={{ ...FontStyles.aboutText }}>

                                We believe that finding the right life partner is one of the most important and difficult tasks of one’s life. Our goal is to help you in the process of finding your perfect partner simplicity to make a living together. We are among the best free Indian wedding website known for perfect matchmaking and our
                                <span style={{
                                    ...FontStyles.aboutSpan
                                }}> www.annapurnamarriages.com</span> offers services in Marriage Counselling and helps people to find their bride and grooms. When you knew that this is the person of your dream! We can help you find your soul mate.
                            </Typography>
                        </Card>
                    </Card>
                </Box>
                <Box sx={{
                    marginTop: "50px", marginBottom: "50px"
                }}>
                    <Card
                        sx={{
                            ...styles.aboutcard,
                            boxShadow: 3,
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                        <Typography variant="h4" component="h1" sx={FontStyles.heading1}>
                            Our Vision                                       </Typography>
                        <Card
                            sx={{
                                ...styles.aboutCard,
                                boxSizing: "border-box",
                            }}
                        >
                            <Typography sx={{ ...FontStyles.aboutText }}>

                                We envision to offer you satisfying and cognizant services while retaining old customers and expand to prophesied ones in this domain. Also, we hope that the marriage - a blissful act, should lucidly facilitating to blend two families to make a new world of turning dreams into reality.
                            </Typography>
                        </Card>
                    </Card>
                </Box>

            </Box>
            <Footer />
        </>
    )
}

export default About